import React from "react";
import PropTypes from "prop-types";
import InvisibleRecaptcha from "components/v3/recaptcha/InvisibleRecaptcha";
import Header from "components/v3/header/Header";
import ErrorHandler from "components/v3/error-handler/ErrorHandler";
import SubmitError from "components/v3/submit-error/SubmitError";
import { FEEDBACK_URL } from "common/constants/Constants";
import styles from "./styles.module.scss";

class ActivationEmail extends React.Component {
    constructor(props) {
        super(props);

        this._onSubmit = this._onSubmit.bind(this);
    }

    _onSubmit(grecaptchaToken) {
        this.props.onSubmit(this.props.email, {
            useRecaptcha: this.props.useRecaptcha,
            captchaResponse: grecaptchaToken
        });
    }

    render() {
        const {
            email,
            signInLink,
            grecaptchaApiKey,
            useRecaptcha,
            errors,
            fromSubscriptionSuccess
        } = this.props;

        const headerContent = !fromSubscriptionSuccess
            && (
                <Header title="Create an Account">
                    <SignInSubtitle signInLink={ signInLink } />
                </Header>
            );

        /*
         * Note that it is possible for there to be a linking error from the BusinessweekRegister screen that has persisted to
         * this screen, thus the multiple error type checking in the jsx
         */
        return (
            <InvisibleRecaptcha
                useRecaptcha={ useRecaptcha }
                onCaptchaResponse={ this._onSubmit }
                grecaptchaApiKey={ grecaptchaApiKey }
            >
                { headerContent }
                <div className={ styles.body }>
                    <div className={ styles.bodyText }>
                        Please check your email, { email }, and follow instructions to finalize your account setup.
                    </div>
                    <ErrorHandler types={ ["register", "linking"] } errors={ errors }>
                        <SubmitError />
                    </ErrorHandler>
                    <div className={ styles.footerText }>
                        Didn&apos;t receive the email?{ " " }
                        <button
                            className={ styles.inlineButton }
                            type="submit"
                        >
                            Resend activation email
                        </button>
                        { " " }or{ " " }
                        <a
                            className={ styles.inlineButton }
                            href={ FEEDBACK_URL }
                        >
                            contact customer support
                        </a>
                        { " " }for further assistance.
                    </div>
                </div>
            </InvisibleRecaptcha>
        );
    }
}

const SignInSubtitle = ({ signInLink }) => {
    return (
        <span className={ styles.signInSubtitle }>
            Already have an account?
            <a className={ styles.signInSubtitleLink } href={ signInLink }>Sign in</a>
        </span>
    );
};

ActivationEmail.propTypes = {
    email: PropTypes.string,
    signInLink: PropTypes.string,
    grecaptchaApiKey: PropTypes.string,
    useRecaptcha: PropTypes.bool,
    errors: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    fromSubscriptionSuccess: PropTypes.bool
};

export default ActivationEmail;
